import { Search } from '@customerio/pluma-components/react';
import * as styles from './directory-tab.css';

type SearchFieldProps = {
  value: string;
  placeholder: string;
  isLoading: boolean;
  onSearch: (value: string) => void;
  onClear: () => void;
};

export function SearchField({ value, placeholder, isLoading, onSearch, onClear }: SearchFieldProps) {
  return (
    <Search
      className={styles.searchField}
      id="search-integrations-input"
      ariaLabel="Search integrations"
      placeholder={isLoading ? 'Loading…' : placeholder}
      value={value}
      isDisabled={isLoading}
      // The directory filters as you type, so every value change is the search.
      onSearchInput={onSearch}
      onSearch={onSearch}
      onClear={onClear}
    />
  );
}
